import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

export const StyledLabel = styled.label`
  & {
    position: relative;
    display: inline-block;
    width: 4rem;
    height: 2.25rem;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    /* stylelint-disable */
    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: ${colors.dust};
      -webkit-transition: 0.4s;
      transition: 0.4s;
      border: 1px solid ${colors.saruman};
    }

    .slider::before {
      position: absolute;
      content: '';
      height: 1.875rem;
      width: 1.875rem;
      left: 3px;
      bottom: 0.125rem;
      background-color: ${colors.saruman};
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    input:checked + .slider {
      border-color: ${colors.adaptBlue};
      background-color: rgba(61, 122, 241, 0.1);
    }

    input:focus + .slider {
      box-shadow: 0 0 1px ${colors.radagast};
    }

    input:checked + .slider::before {
      -webkit-transform: translateX(1.625rem);
      -ms-transform: translateX(1.625rem);
      transform: translateX(1.625rem);
      background-color: ${colors.adaptBlue};
    }
    /* stylelint-enable */

    /* Rounded sliders */
    .slider.round {
      border-radius: 34px;
    }

    .slider.round::before {
      border-radius: 50%;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/StyledCheckbox/StyledCheckbox.style.tsx